"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var table_item_deserializer_service_1 = require("./service/table-item-deserializer.service");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var router_1 = require("@angular/router");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var form_properties_1 = require("../../shared/model/form-properties");
var form_resolution_service_1 = require("../../shared/services/api/form-resolution.service");
var DynamicTableComponent = /** @class */ (function () {
    function DynamicTableComponent(kbService, entitySearchService, classifierService, currentLanguageProvider, ugaDynamicPortfolioService, formResolutionService, router) {
        this.kbService = kbService;
        this.entitySearchService = entitySearchService;
        this.classifierService = classifierService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.ugaDynamicPortfolioService = ugaDynamicPortfolioService;
        this.formResolutionService = formResolutionService;
        this.router = router;
        this.handleNavigation = false;
        this.isDrawer = false;
        this.portfolioItemsChange = new core_1.EventEmitter();
        this.portfolioItemClick = new core_1.EventEmitter();
        this._currentPage = 0;
        this.isLoading = false;
        this.isReady = false;
        this.onChanges$ = new ReplaySubject_1.ReplaySubject(1);
        this._destroy$ = new Subject_1.Subject();
    }
    DynamicTableComponent.prototype.ngOnDestroy = function () {
        this.onChanges$.complete();
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    DynamicTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.navColumnName) {
            this.navColumnName = this.columnSystemNames[0];
        }
        this.setDefaultSortingOptions();
        this.portfolioData$ = this.onChanges$
            .switchMap(function (data) {
            return _this.loadPortfolioItems();
        }).publishReplay(1).refCount().map(function (value) {
            _this.isLoading = false;
            _this.portfolioItemsChange.emit(value);
            return value;
        }, function (error) {
            console.error(error);
            _this.isLoading = false;
        });
    };
    DynamicTableComponent.prototype.ngOnChanges = function (changes) {
        if (changes['filterCriteria']) {
            this._currentPage = 0;
        }
        this.onChanges$.next(changes);
    };
    Object.defineProperty(DynamicTableComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (value) {
            this._currentPage = value;
            this.onChanges$.next(null);
        },
        enumerable: true,
        configurable: true
    });
    // Helper methods
    DynamicTableComponent.prototype.setDefaultSortingOptions = function () {
        this.sortingDirection = this.sortingDirection ? this.sortingDirection : (!this.externalFilter ? idm_de_core_frontend_1.SortType.ASC : 'ASC');
        this.defaultSortingField ?
            (this.sortingOption = !this.externalFilter ? new idm_de_core_frontend_1.SortingOptions(this.defaultSortingField, this.sortingDirection) : this.getSortingForExternal())
            : this.sortingOption = null;
    };
    DynamicTableComponent.prototype.getSortingForExternal = function () {
        var sorting = {};
        sorting[this.defaultSortingField] = this.sortingDirection;
        return sorting;
    };
    DynamicTableComponent.prototype.loadPortfolioItems = function () {
        var _this = this;
        this.isLoading = true;
        return this.ugaDynamicPortfolioService.loadPortfolioItems(this.categorySystemName, this.columnSystemNames, this.columnSystemNamesInvisable, new idm_de_core_frontend_1.PagingOptions(this._currentPage, this.pageLimit), this.filterCriteria, this.sortingOption, this.pageLimit, this.externalFilter, this.permissionType)
            .map(function (portfolioData) {
            _this.isLoading = false;
            return portfolioData;
        });
    };
    DynamicTableComponent.prototype.navigate = function (portfolioItem) {
        this.openCategory(portfolioItem);
    };
    DynamicTableComponent.prototype.openCategory = function (portfolioItem) {
        var _this = this;
        if (!this.formId) {
            this.formResolutionService.getEntityFormProperties(this.categorySystemName, portfolioItem.entityInstanceId, portfolioItem.entitySearchItem)
                .pipe(operators_1.takeUntil(this._destroy$))
                .subscribe(function (formProperties) {
                _this.openEntity(formProperties, portfolioItem.entityInstanceId);
            });
        }
        else {
            this.openEntity(new form_properties_1.FormProperties(this.formId, this.deFormName, this.formId, this.deFormName), portfolioItem.entityInstanceId);
        }
    };
    DynamicTableComponent.prototype.openEntity = function (formProperties, entityId) {
        var url = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["dynamic-de/", "/", "/", "/", ""], ["dynamic-de/", "/", "/", "/", ""])), 'category', 'formName', 'formId', 'instanceId').replaceTemplate({
            'category': this.categorySystemName,
            'formName': formProperties.viewFormName,
            'formId': formProperties.viewFormId + '',
            'instanceId': entityId + ''
        });
        if (this.handleNavigation) {
            window.open(url);
        }
        else {
            this.portfolioItemClick.emit({
                category: this.categorySystemName,
                entityId: entityId,
                formProperties: formProperties
            });
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "categorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DynamicTableComponent.prototype, "columnSystemNames", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DynamicTableComponent.prototype, "columnSystemNamesInvisable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DynamicTableComponent.prototype, "columnsCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "deFormName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DynamicTableComponent.prototype, "formId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DynamicTableComponent.prototype, "pageLimit", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "permissionType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.FilterCriteria)
    ], DynamicTableComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicTableComponent.prototype, "externalFilter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "defaultSortingField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicTableComponent.prototype, "sortingDirection", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicTableComponent.prototype, "navColumnName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicTableComponent.prototype, "handleNavigation", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicTableComponent.prototype, "isDrawer", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DynamicTableComponent.prototype, "portfolioItemsChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DynamicTableComponent.prototype, "portfolioItemClick", void 0);
    __decorate([
        core_1.ContentChild('customHeaderBehind'),
        __metadata("design:type", core_1.TemplateRef)
    ], DynamicTableComponent.prototype, "headerTmpl", void 0);
    __decorate([
        core_1.ContentChild('customHeaderFront'),
        __metadata("design:type", core_1.TemplateRef)
    ], DynamicTableComponent.prototype, "frontHeaderTmpl", void 0);
    __decorate([
        core_1.ContentChild('customColumn'),
        __metadata("design:type", core_1.TemplateRef)
    ], DynamicTableComponent.prototype, "columnTmpl", void 0);
    __decorate([
        core_1.ContentChild('customColumnFront'),
        __metadata("design:type", core_1.TemplateRef)
    ], DynamicTableComponent.prototype, "frontColumnTmpl", void 0);
    __decorate([
        core_1.ContentChild('customContent'),
        __metadata("design:type", core_1.TemplateRef)
    ], DynamicTableComponent.prototype, "contentTmpl", void 0);
    DynamicTableComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-dynamic-table',
            template: require('./dynamic-table.component.html'),
            styles: [require('./dynamic-table.component.css')],
            providers: [table_item_deserializer_service_1.TableItemDeserializerService]
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_entity_search_client_js_1.EntitySearchService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            table_item_deserializer_service_1.TableItemDeserializerService,
            form_resolution_service_1.FormResolutionService,
            router_1.Router])
    ], DynamicTableComponent);
    return DynamicTableComponent;
}());
exports.DynamicTableComponent = DynamicTableComponent;
var templateObject_1;
//# sourceMappingURL=dynamic-table.component.js.map